import { isInsightsEnabledForUser } from 'owa-meeting-insights-types-and-flights';
import TimeConstants from 'owa-datetime-utils/lib/TimeConstants';
import { initializeEventRelatedContent } from '../actions/publicActions';
import { makePutRequest } from 'owa-ows-gateway';
import { trace } from 'owa-trace';
import { orchestrator } from 'satcheljs';

const RELATED_CONTENT_WARMUP_URL = 'ows/api/beta/events/relatedContent/warmup';

let hasRequestedWarmup: boolean = false;
let hasInitializedTimer: boolean = false;

export default orchestrator(initializeEventRelatedContent, async () => {
    // Issue the warmup call to initialize the event related content if it is enabled for user
    if (isInsightsEnabledForUser()) {
        try {
            if (!hasRequestedWarmup) {
                hasRequestedWarmup = true;
                // Note: we are passing returnFullResponse to avoid an error with makePutRequest
                // trying to parse the response because warmup doesn't return any. We might want
                // to change that and return the trace ID that 3S returns
                await makePutRequest(
                    RELATED_CONTENT_WARMUP_URL,
                    {},
                    '' /*correlationId*/,
                    true /*returnFullResponse*/
                );
            }

            // Set the timer to repeat the action in the next 24hs
            if (!hasInitializedTimer) {
                window.setTimeout(
                    initializeEventRelatedContent,
                    TimeConstants.MillisecondsInOneDay
                );
                hasInitializedTimer = true;
            }
        } catch (e) {
            hasRequestedWarmup = false;
            trace.warn(`[initializeEventRelatedContent failed] : ${e}`);
        }
    }
});
